<template>
  <b-modal
    :visible="true"
    title-class="h5 text-dark"
    hide-footer
    centered
    @hide="$emit('close')"
  >
    <!-- Title -->
    <template #modal-title>
      {{ data.name }}
    </template>

    <!-- Quantity Adjustment -->
    <div class="d-flex align-items-center justify-content-center my-3">
      <b-button @click="adjust(-1)" variant="outline-primary" class="px-3">–</b-button>
      <div class="mx-4 text-center">
        <div class="h3 font-weight-bold mb-0">{{ quantity }}</div>
        <small class="text-muted">{{ $t('myhealth.minutes') }}</small>
      </div>
      <b-button @click="adjust(1)" variant="outline-primary" class="px-3">+</b-button>
    </div>

    <!-- Computed Points -->
    <p class="text-center text-success font-weight-semibold">
      +{{ computedPoints }} {{ $t('myhealth.points') }}
    </p>
    <p class="text-center text-muted small mb-0">
    {{ recordedText }}
    </p>    

    <!-- Actions -->
    <div class="d-flex justify-content-between mt-4">
      <b-button variant="outline-primary" @click="$emit('close')">
        {{ $t('myhealth.cancel') }}
      </b-button>
      <b-button variant="primary" @click="save">
        {{ $t('myhealth.submit') }}
      </b-button>
    </div>
  </b-modal>
</template>


<script>
export default {
  name: "QuickReportModal",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      quantity: this.data.defaultQuantity || 10,
    }
  },
  computed: {
    computedPoints() {
        const pointValue = parseFloat(this.data.points) || 0
        const stepsPerMinute = this.data.stepsPerMinute || 0
        return Math.floor(this.quantity * stepsPerMinute * pointValue)
    },
    recordedText() {
        const dateStr = new Date().toLocaleDateString(this.$i18n.locale, {
        weekday: undefined,
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        })
        return `${this.$t('myhealth.recorded_today')} (${dateStr})`
    }    
  },
  methods: {
    adjust(val) {
      this.quantity = Math.max(1, this.quantity + val)
    },
    save() {
      this.$emit("save", {
        activity_id: this.data.id,
        quantity: this.quantity,
      })
    },
  },
}
</script>
